export default __webpack_public_path__ + "static/media/C242251.451d3008.jpg";